module.exports = __webpack_public_path__ + "static/media/img97.c6357110.jpg";